import { SvgIconProps } from "@mui/material";
import { ThemedFillSvgIcon } from "src/theme-mui/components/svg-icon/themed-fill-svg-icon";

export const IconCopy = (props: SvgIconProps) => (
    <ThemedFillSvgIcon {...props} width="24" height="24" viewBox="0 0 24 24">
        <defs>
            <mask id="copy-mask" maskUnits="userSpaceOnUse">
                <rect x="3" y="8" width="13" height="13" rx="2" fill="white" stroke="white" strokeWidth="2" />
                <rect x="8" y="3" width="13" height="13" rx="2" fill="black" stroke="black" strokeWidth="2" />
            </mask>
        </defs>
        <rect x="3" y="8" width="13" height="13" rx="2" fill="transparent" stroke="#333333" strokeWidth="2" mask="url(#copy-mask)" />
        <rect x="8" y="3" width="13" height="13" rx="2" fill="transparent" stroke="#333333" strokeWidth="2" />
    </ThemedFillSvgIcon>
);
